import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "auth-modal" }
const _hoisted_3 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "switch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "auth-modal-overlay",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": _ctx.isLogin ? '登录' : '注册',
    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.isLogin ? '登录' : '创建账号'), 1),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              class: "sr-only",
              for: "auth-account"
            }, "邮箱", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "auth-account",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account) = $event)),
              placeholder: "邮箱",
              autocomplete: "username",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.account]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              class: "sr-only",
              for: "auth-password"
            }, "密码", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "auth-password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              placeholder: "密码",
              autocomplete: "current-password",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.password]
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "primary",
              disabled: _ctx.loading,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)))
            }, _toDisplayString(_ctx.loading ? '登录中...' : '登录'), 9, _hoisted_4)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[14] || (_cache[14] = _createElementVNode("label", {
              class: "sr-only",
              for: "register-email"
            }, "邮箱", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "register-email",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerEmail) = $event)),
              type: "email",
              placeholder: "邮箱地址",
              autocomplete: "username",
              onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitRegister && _ctx.submitRegister(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.registerEmail]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("label", {
              class: "sr-only",
              for: "register-password"
            }, "密码", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "register-password",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registerPassword) = $event)),
              type: "password",
              placeholder: "密码（至少 8 位）",
              autocomplete: "new-password",
              onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitRegister && _ctx.submitRegister(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.registerPassword]
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "primary",
              disabled: _ctx.loading,
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitRegister && _ctx.submitRegister(...args)))
            }, _toDisplayString(_ctx.loading ? '注册中...' : '注册并登录'), 9, _hoisted_6),
            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "terms" }, "注册即表示同意用户协议与隐私政策", -1))
          ], 64)),
      _createElementVNode("p", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.isLogin ? '还没有账号？' : '已有账号？') + " ", 1),
        _createElementVNode("a", {
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleMode && _ctx.toggleMode(...args)))
        }, _toDisplayString(_ctx.isLogin ? '去注册' : '去登录'), 1)
      ])
    ])
  ], 8, _hoisted_1))
}